import { TilesMatchHeight } from './../../Libraries/TilesMatchHeight'
import BaseLoader from './BaseLoader';

/**
 * TilesLoader
 *
 * extends the baseLoader specially for tiles
 * In the last iteration the tiles get equalized
 *
 * loads xhr for specific nodes
 * how to use: data-tncp-autoloader="tiles" data-tncp-xhr="/this/is/my/resource"
 *
 */
export default class TilesLoader extends BaseLoader {

    constructor(selector) {
        super(selector);
        this.counter = 0;
    }

    onSuccess($element, response) {
        this.counter++;
        const dataAttributes = $element.data();
        // Content normalisieren
        let content = response.data.content;
        if (content === null || (typeof content === 'string' && content.trim() === '')) {
            content = '';
        }

        // if tncpAutoloaderMultiple is set, jquery will traverse of to o-layout__item u-1/2-lap u-1/3-desk and paste the info after
        if (dataAttributes.tncpAutoloaderMultiple === true) {
            $element.parent().after(content);
            $element.parent().remove();
        } else {
            $element.html(content);
        }

        // if hide if empty is set and content is empty, then remove also the parent wrapper element
        if (dataAttributes.tncpAutoloaderHideifempty === true && content === '') {
            $element.parent().remove();
        }

        // Equalize height of tiles with MatchHeight on last iteration
        if (this.counter === this.elements.length) {
            setTimeout(function() {
                new TilesMatchHeight().execute();
            }, 1000);
        }
    }
}
